import * as paper from 'paper';
import {Point} from "paper";
import {MathFunctions, SimpleLine} from "./includes/mathHelper"
import {DrawData, EdgeColorData} from "./drawData";
import {DisplayFunctions} from "./includes/displayFunctions";
import {ApiService} from "./includes/apiService";

export class DataLayer {
    drawDataObj: DrawData;

    constructor(drawDataObj: DrawData) {
        this.drawDataObj = drawDataObj;
    }

    getItemizedCharges() {
        if (!this.drawDataObj.CounterTopArr || this.drawDataObj.CounterTopArr.length === 0 || !this.drawDataObj.CounterTopArr[0].edgecolor) {
            return [];
        }

        var laborChargesArr = this.getLaborCharges();
        var materialChargesArr = this.getMaterialSqFtArr();
        var laminateChargesArr = this.getLaminateCharges();
        return materialChargesArr.concat(laborChargesArr).concat(laminateChargesArr);
    }

    getProdQteGroups() {
        if (!this.drawDataObj.CounterTopArr || this.drawDataObj.CounterTopArr.length === 0 || !this.drawDataObj.CounterTopArr[0].edgecolor) {
            return [];
        }

        let result = new Set<number>()

        for (var i = 0; i < this.drawDataObj.CounterTopArr.length; i++) {
            let ec = (<any>this.drawDataObj.CounterTopArr[i].edgecolor).ec;
            let prodQteGroupId = ec.p as number;
            if (prodQteGroupId) {
                result.add(prodQteGroupId);
            }
        }

        return Array.from(result);
    }

    getMaterialProducts() {
        if (!this.drawDataObj.CounterTopArr || this.drawDataObj.CounterTopArr.length === 0 || !this.drawDataObj.CounterTopArr[0].edgecolor) {
            return [];
        }

        let result = new Set<number>()

        for (var i = 0; i < this.drawDataObj.CounterTopArr.length; i++) {
            let ec = (<any>this.drawDataObj.CounterTopArr[i].edgecolor).ec;
            let colorId = ec.c as number;
            if (colorId) {
                result.add(colorId);
            }
        }

        return Array.from(result);
    }

    getMaterialSqFtArr() {
        var uniqueMaterialSums: any = {};//treat like dictionary.
        var curMaterial, curSum, curEntry, ec;

        for (var i = 0; i < this.drawDataObj.CounterTopArr.length; i++) {
            ec = (<any>this.drawDataObj.CounterTopArr[i].edgecolor).ec;
            curMaterial = ec.c as number;
            curEntry = uniqueMaterialSums[curMaterial];
            if (curEntry) {
                curSum = curEntry.quantity;

            } else {
                curSum = 0;
                curEntry = {productID: curMaterial};
            }
            curSum += this.getCounterMaterialArea(this.drawDataObj.CounterTopArr[i].path, ec);
            curEntry.quantity = curSum;
            uniqueMaterialSums[curMaterial] = curEntry;
        }
        var arr = [];
        for (let material in uniqueMaterialSums) {
            arr.push({ProductID: <any>material, Quantity: uniqueMaterialSums[material].quantity});//, UOM:'Sq. Ft.'});
        }
        return arr;
    }

    getLaborCharges() {
        var uniqueLaborCharges: any = {};
        var path, ec;
        DataLayer.addDataItemsTo(uniqueLaborCharges, this.getSinkAndCutoutItems(null));
        for (var i = 0; i < this.drawDataObj.CounterTopArr.length; i++) {
            path = this.drawDataObj.CounterTopArr[i].path;
            ec = (<any>this.drawDataObj.CounterTopArr[i].edgecolor).ec;
            DataLayer.addDataItemsTo(uniqueLaborCharges, this.getSinkAndCutoutItems(path));
            if (!DataLayer.isLaminate(ec)) {
                DataLayer.addDataItemsTo(uniqueLaborCharges, this.getInsideDiagonalItems(path));
            }
            DataLayer.addDataItemsTo(uniqueLaborCharges, this.getCornerRadiusItems(path));
            DataLayer.addDataItemsTo(uniqueLaborCharges, this.getClippedCornerItems(path));
            DataLayer.addDataItemsTo(uniqueLaborCharges, this.getFullRadiusLaborItems(path));
            DataLayer.addDataItemsTo(uniqueLaborCharges, this.getSplashLaborInches(path, ec));
            DataLayer.addDataItemsTo(uniqueLaborCharges, this.getEdgeLaborInches(path, ec));
            DataLayer.addDataItemsTo(uniqueLaborCharges, this.getJointItems(path, ec));
        }
        var arr = [];
        for (let productID in uniqueLaborCharges) {
            arr.push({ProductID: productID, Quantity: uniqueLaborCharges[productID].qty});
        }
        return arr;
    }

    getLaminateCharges() {
        var uniqueCharges: any = {};
        for (var i = 0; i < this.drawDataObj.CounterTopArr.length; i++) {
            var path = this.drawDataObj.CounterTopArr[i].path;
            for (var j = 0; j < path.segments.length; j++) {
                var segment: any = path.segments[j];
                if (segment.data) {
                    if (segment.data.edgeLaminateProducts) {
                        if (segment.data.edgeLaminateProducts.capProductId) {
                            var tempDataObj: any = {};
                            tempDataObj[segment.data.edgeLaminateProducts.capProductId] = {qty: 1};
                            DataLayer.addDataItemsTo(uniqueCharges, tempDataObj);
                        }
                        if (segment.data.edgeLaminateProducts.splashProductId) {
                            var tempDataObj: any = {};
                            tempDataObj[segment.data.edgeLaminateProducts.splashProductId] = {qty: 1};
                            DataLayer.addDataItemsTo(uniqueCharges, tempDataObj);
                        }
                    }
                    if (segment.data.tempSmoothingData && segment.data.tempSmoothingData.productId) {
                        var tempDataObj: any = {};
                        tempDataObj[segment.data.tempSmoothingData.productId] = {qty: 1};
                        DataLayer.addDataItemsTo(uniqueCharges, tempDataObj);
                    }
                }
            }
        }
        var arr = [];
        for (let productID in uniqueCharges) {
            arr.push({ProductID: productID, Quantity: uniqueCharges[productID].qty});
        }
        return arr;
    }

    async getJointItems(path: any, ec: any) {
        //var numInches = 0;
        let retVal: any = {}, temp: any;
        if (path.segments.length <= 4) {
            return retVal;
        }
        const productId = ApiService.getJointProductIDs()[ec.c];
        if (productId) {
            temp = {};
            let count = 0;
            for (let i = 0; i < path.segments.length; i++) {
                if (path.segments[i].angleDrawDataObj) {
                    count++;
                }
            }
            if (count > 0) {
                temp[productId] = {qty: count};
                DataLayer.addDataItemsTo(retVal, temp);
            }
        }

        return retVal;
    }

    getEdgeLaborInches(path: any, ec: any) {
        //var numInches = 0;
        var segments = path.segments;
        var segment, productID;
        var retVal: any = {}, temp: any, length;
        for (var i = 0; i < segments.length; i++) {
            segment = segments[i];
            if (segment.data.edgeData) {
                temp = {};
                //productID = segment.data.edgeData.selectedUpgrades[0].edgeID;
                productID = (<any>this.drawDataObj.CounterTopArr[path.pathIndex].edgecolor).ec.e1;
                if (productID) {
                    length = this.drawDataObj.getComplexCurveLength(segment.path.curves[segment.index]);
                    if ((segment.data.smoothingData && segment.data.smoothingData.type == 1) || segment.data.radiusData) {
                        length = DisplayFunctions.CeilPixelToInch(length);
                    } else {
                        length = DisplayFunctions.RoundPixelToInch(length);
                    }
                    temp[productID] = {qty: length};
                    DataLayer.addDataItemsTo(retVal, temp);
                }
            }
        }
        return retVal;
    }

    getSplashLaborInches(path: any, ec: any) {
        //var numInches = 0;
        var segments = path.segments;
        var segment, productID;
        var retVal = {}, temp: any, length;
        for (var i = 0; i < segments.length; i++) {
            segment = segments[i];
            if (segment.data.splashData && segment.data.splashData.selectedUpgrades != null && segment.data.splashData.selectedUpgrades.length > 0) {
                temp = {};
                productID = segment.data.splashData.selectedUpgrades[0].Id;
                //productID = CounterTopArr[path.pathIndex].edgecolor.ec.b1;
                if (productID) {
                    length = this.drawDataObj.getComplexCurveLength(segment.path.curves[segment.index]);
                    if ((segment.data.smoothingData && segment.data.smoothingData.type == 1) || segment.data.radiusData) {
                        length = DisplayFunctions.CeilPixelToInch(length);
                    } else {
                        length = DisplayFunctions.RoundPixelToInch(length);
                    }
                    temp[productID] = {qty: length};
                    DataLayer.addDataItemsTo(retVal, temp);
                }
            }
        }

        return retVal;
    }

    getFullRadiusLaborItems(path: any) {
        var segments = path.segments;
        var segment, productId: string;
        var retVal: any, temp: any;
        var ec = this.drawDataObj.getEdgeColorFromPath(path);
        if (ec && DataLayer.isLaminate(ec.ec)) {
            for (var i = 0; i < segments.length; i++) {
                segment = segments[i];
                if (segment.data.radiusData) {
                    temp = {};
                    let productQuoteGroupID = this.drawDataObj.getProductQuoteGroup(path);
                    if (productQuoteGroupID != null) {
                        var laminateProductId = ApiService.getLaminateFullRadiusProductID(productQuoteGroupID);
                        if (laminateProductId !== -1) {
                            if (!retVal) {
                                retVal = {};
                            }
                            temp[laminateProductId] = {qty: 1};
                            DataLayer.addDataItemsTo(retVal, temp);
                        }
                    }
                }
            }

            if (!retVal) {
                return {};
            }

            return retVal;
        }

        for (var i = 0; i < segments.length; i++) {
            segment = segments[i];
            if (segment.data.radiusData) {
                temp = {};
                productId = DrawData.createRadiusLegendText(segment.data.radiusData.trueRadius);
                if (productId !== "rs") {
                    if (!retVal) {
                        retVal = {};
                    }
                    temp[productId] = {qty: 1};
                    DataLayer.addDataItemsTo(retVal, temp);
                }
            }
        }
        if (retVal)
            return DataLayer.convertRadiusLegendsToProductIDs(this.drawDataObj.getProductQuoteGroup(path), retVal);
        return {};
    }

    getCornerRadiusItems(path: any) {
        //var numCornerRadiuses = 0;
        var segments = path.segments;
        var segment, productId: string, temp: any;
        var retVal;
        for (var i = 0; i < segments.length; i++) {
            segment = segments[i];
            if (segment.data.smoothingData && segment.data.smoothingData.type == 1) {
                //numCornerRadiuses++;
                //productID = segment.data.smoothingData.productID;
                temp = {};
                //if(!productID) {
                productId = DrawData.createRadiusLegendText(segment.data.smoothingData.depth, true);
                //}
                if (productId !== "rs") {
                    if (!retVal) {
                        retVal = {};
                    }
                    temp[productId] = {qty: 1};
                    DataLayer.addDataItemsTo(retVal, temp);
                }
            }
        }
        if (retVal)
            return DataLayer.convertRadiusLegendsToProductIDs(this.drawDataObj.getProductQuoteGroup(path), retVal, true);
        return retVal;
    }

    getClippedCornerItems(path: any) {
        //var numCornerRadiuses = 0;
        var segments = path.segments;
        var retVal = {};
        for (var i = 0; i < segments.length; i++) {
            var segment = segments[i];
            if (segment.data.smoothingData && segment.data.smoothingData.type == 3) {
                var temp: any = {};
                let productQuoteGroupID = this.drawDataObj.getProductQuoteGroup(path);
                if (productQuoteGroupID != null) {
                    var productId = ApiService.getClippedCornerProductID(productQuoteGroupID);
                    if (productId !== -1) {
                        temp[productId] = {qty: 1};
                        DataLayer.addDataItemsTo(retVal, temp);
                    }
                }
            }
        }
        return retVal;
    }

    getInsideDiagonalItems(path: any) {
        var numDiagonals = 0;
        var segments = this.getInsideSegments(path, false);
        var segment;
        for (var i = 0; i < segments.length; i++) {
            segment = segments[i];
            if (segment.data.smoothingData && segment.data.smoothingData.type == 2) {
                numDiagonals++;
                //productID = segment.data.smoothingData.productID; //only need a single productID, tracking qty with numDiagonals.
            }
        }
        var retVal: any = {};
        if (numDiagonals) {
            let productQuoteGroupID = this.drawDataObj.getProductQuoteGroup(path);
            if (productQuoteGroupID != null) {
                var productId = ApiService.getDiagonalProductID(productQuoteGroupID);
                if (productId !== -1)
                    retVal[productId] = {qty: numDiagonals};
            }
        }
        return retVal;
    }

    static addDataItemsTo(curDataObj: any, tempDataObj: any) {
        var tempValue, value;//SKU, {...}.
        for (let key in tempDataObj) {
            tempValue = tempDataObj[key];
            value = curDataObj[key];
            if (!value) {
                value = tempValue;
            } else {
                value.qty += tempValue.qty;
            }
            curDataObj[key] = value;
        }
    }

    getSinkAndCutoutItems(path: any) {
        var laborItems = {};
        var curSink, tempDataObj: any;
        var sinkArr, pqgID: any;
        if (!path) {
            sinkArr = this.drawDataObj.FloatingItems.sinkArr;
        } else {
            sinkArr = this.drawDataObj.CounterTopArr[path.pathIndex].sinkArr;
            if (!sinkArr) {
                return laborItems;
            }
        }

        for (var i = 0; i < sinkArr.length; i++) {
            curSink = sinkArr[i];
            switch (curSink.typeID.typeEnum) {
                case 1: {
                    //sink SKU (+ sink labor ProductID? Server-Side)
                    tempDataObj = {};
                    if (curSink.typeID.sinkID > 5) {
                        tempDataObj[curSink.typeID.sinkID] = {qty: 1};
                    }
                    if (path)
                        pqgID = this.drawDataObj.getProductQuoteGroup(path);
                    else
                        pqgID = null;
                    let productId = ApiService.getSinkInstallProductID(pqgID, curSink.typeID.sinkID, curSink.typeID.ironType);
                    if (productId > 0) {
                        tempDataObj[productId] = {qty: 1};
                    }
                    DataLayer.addDataItemsTo(laborItems, tempDataObj);
                    break;
                }
                case 2: {
                    //(electrical) cutout ProductID

                    tempDataObj = {};
                    if (path) {
                        pqgID = this.drawDataObj.getProductQuoteGroup(path);
                        pqgID = ApiService.getCutoutProductID(pqgID);
                        tempDataObj[pqgID] = {qty: 1};
                    } else {
                        pqgID = null;

                        tempDataObj[curSink.typeID.sinkID] = {qty: 1};
                    }

                    DataLayer.addDataItemsTo(laborItems, tempDataObj);
                    break;
                }
                case 3: {
                    //Cooktop: no charge.

                    break;
                }
                default: {
                    break;
                }
            }
        }
        return laborItems;
    }

    getCounterMaterialArea(path: any, ec: any) {
        var area = 0;

        this.drawDataObj.removeBumpIns(path);

        area += this.sumSplashArea(path);
        area += DataLayer.sumOutwardRadiuses(path);//make a rectangle.
        DrawData.convertCounterToSimpleCounter(path);//Removes (& handles) OutsideCornerDiagonals and RadiusIn.
        area += DataLayer.sumBumpOuts(path);//make a large rectangle.
        this.drawDataObj.removeBumpOuts(path);
        area += this.sumInsideDiagonals(path, true);//use(add) a Square of depth.
        area += DataLayer.calculatePathArea(path);
        area += this.calculateExtraSquareForWoodProduct(path, ec);
        if (DataLayer.isLaminate(ec)) {
            area += this.calculateExtraSquare(path);
        }
        area = Math.ceil(area);
        area = area / (12 * 12); //convert to Sq. Ft.
        return Math.ceil(area);
    }


    sumInsideDiagonals(path: any, useTempData: any) {
        //have to check if diagonal is on an inner segment.
        var segments = this.getInsideSegments(path, useTempData);
        var segment;
        var sum = 0;

        for (var i = 0; i < segments.length; i++) {
            segment = segments[i];
            if (useTempData) {
                if (segment.data.tempSmoothingData && segment.data.tempSmoothingData.type != 1 && (!segment.data.bumpGroupData || !segment.data.bumpGroupData.bumpIn) && (!segment.previous.data.bumpGroupData || !segment.data.bumpGroupData.bumpIn)) {
                    sum += segment.data.tempSmoothingData.depth * segment.data.tempSmoothingData.depth;
                }
            } else {
                if (segment.data.smoothingData && segment.data.smoothingData.type != 1 && (!segment.data.bumpGroupData || !segment.data.bumpGroupData.bumpIn) && (!segment.previous.data.bumpGroupData || !segment.data.bumpGroupData.bumpIn)) {
                    sum += segment.data.smoothingData.depth * segment.data.smoothingData.depth;
                }
            }
        }
        return sum;
    }

    calculateExtraSquareForWoodProduct(path: any, ec: any) {
        var summ = 0;

        let pId = parseInt(ec.c);
        let ids = ApiService.getWoodProductIDs();
        if (!ids)
            return summ;

        if (ids.indexOf(pId) !== -1) {
            return this.calculateExtraSquare(path);
        }
        return summ;
    }

    calculateExtraSquare(path: any) {
        var summ = 0;

        for (let j = 0; j < path.segments.length; j++) {
            let segment = <any>path.segments[j];
            if (segment.pairedAngle && segment.isOuterAngle) {
                let line = {point1: segment.point, point2: segment.pairedAngle.point}
                let a = DisplayFunctions.RoundPixelToInch(line.point1.x > line.point2.x ? line.point1.x - line.point2.x : line.point2.x - line.point1.x);
                let b = DisplayFunctions.RoundPixelToInch(line.point1.y > line.point2.y ? line.point1.y - line.point2.y : line.point2.y - line.point1.y);
                summ += a * b
            }
        }

        return summ;
    }


    getInsideSegments(path: any, isSimpleCounter: any) {
        var segments = path.segments;
        var segment;
        var arr = [];

        if (isSimpleCounter) {
            var testPoint, vIn1, vIn2;

            for (let i = 0; i < segments.length; i++) {
                segment = segments[i];
                vIn1 = MathFunctions.getVectorBetweenPoints(segment.previous.point, segment.point).normalize(2);
                vIn2 = MathFunctions.getVectorBetweenPoints(segment.next.point, segment.point).normalize(2);
                testPoint = MathFunctions.addVectors(segment.point, MathFunctions.addVectors(vIn1, vIn2));
                if (this.drawDataObj.isInSelectedPath(testPoint, path)) {
                    arr.push(segment);
                }
            }
            return arr;
        }
        //else:
        var bgd, tempSeg;
        for (let i = 0; i < segments.length; i++) {
            segment = segments[i];
            if (segment.isOuterAngle == false) {
                arr.push(segment);
            } else if (segment.data.bumpGroupData) {
                bgd = segment.data.bumpGroupData;
                if (bgd.bumpIn) {
                    if ((segment == bgd.tangentSide) || (segment == bgd.side2)) {
                        arr.push(segment);
                    }
                } else {
                    if (segment == bgd.side1) {
                        arr.push(DrawData.getSmoothedStart(segment));
                        tempSeg = DrawData.getSmoothedEnd(segment);
                        if (tempSeg.index >= i) {
                            i = tempSeg.index;
                        } else {
                            i = segments.length;
                        }
                    } else if (segment == bgd.side2) {
                        tempSeg = DrawData.getSmoothedNextSegment(segment);
                        arr.push(tempSeg);
                        if (tempSeg.index >= i) {
                            i = tempSeg.index;
                        } else {
                            i = segments.length;
                        }
                    }
                }
            }
        }
        return arr;
    }

    sumSplashArea(path: any) {
        var segments = path.segments;
        //Sum for CookTop Splash
        var cookTopSplashArr;
        if (!path) {
            if (this.drawDataObj.FloatingCookTopSplashItems && this.drawDataObj.FloatingCookTopSplashItems.cookTopSplashArr) {
                cookTopSplashArr = this.drawDataObj.FloatingCookTopSplashItems.cookTopSplashArr;
            }
        } else {
            if (this.drawDataObj.CounterTopArr[path.pathIndex].cookTopSplashArr) {
                cookTopSplashArr = this.drawDataObj.CounterTopArr[path.pathIndex].cookTopSplashArr;
            }
        }

        var segment;
        var sum = 0, width = 0, height = 0, length = 0, oldSegPoint, angle, heightInches = 0;
        for (let i = 0; i < segments.length; i++) {
            segment = segments[i];
            if (segment.data.splashData) {

                if (segment.data.radiusData && (segment.data.radiusData.direction == 1)) {
                    width = DisplayFunctions.RoundPixelToInch(MathFunctions.getDistanceBetween(segment.point, segment.next.point));

                    length = MathFunctions.calculateArcLength(width, segment.data.radiusData.depth);

                } else if (segment.data.smoothingData && segment.data.smoothingData.type == 1) {
                    oldSegPoint = DrawData.getSmoothedPoint(segment);
                    angle = DisplayFunctions.customRound(MathFunctions.calculateAngleFromLines(new SimpleLine(segment.point, oldSegPoint), (new SimpleLine(oldSegPoint, segment.next.point))), 2);
                    length = MathFunctions.convertToRadians(180 - angle) * segment.data.smoothingData.depth;//radius in inches * angle in radians = length in inches.
                } else {
                    length = DisplayFunctions.RoundPixelToInch(this.drawDataObj.getComplexCurveLength(segment.path.curves[segment.index]));
                }

                if (cookTopSplashArr && cookTopSplashArr.length > 0) {
                    var widthCookTop = 0, lengthCookTop = 0;
                    var segmentCookTopX = 0, segmentCookTopY = 0;
                    for (var j = 0; j < cookTopSplashArr.length; j++) {
                        if (cookTopSplashArr[j].segment.point) {
                            segmentCookTopX = cookTopSplashArr[j].segment.point.x;
                            segmentCookTopY = cookTopSplashArr[j].segment.point.y;
                        } else {
                            segmentCookTopX = cookTopSplashArr[j].segment[1];
                            segmentCookTopY = cookTopSplashArr[j].segment[2];
                        }

                        if (segmentCookTopX === segment.point.x
                            && segmentCookTopY === segment.point.y) {
                            cookTopSplashArr[j].group.rotate(-1 * cookTopSplashArr[j].group.data.angle);
                            widthCookTop = cookTopSplashArr[j].group.children['CookTopSplashTracker'].bounds.width;
                            lengthCookTop = DisplayFunctions.RoundPixelToInch(widthCookTop);   //Lenght of CookTop Splash

                            sum = sum - (lengthCookTop * segment.data.splashData.splashHeightInInches);
                        }
                    }
                }

                sum += length * segment.data.splashData.splashHeightInInches;
            }
        }

        if (cookTopSplashArr && cookTopSplashArr.length > 0) {
            for (let i = 0; i < cookTopSplashArr.length; i++) {
                cookTopSplashArr[i].group.rotate(-1 * cookTopSplashArr[i].group.data.angle);

                width = cookTopSplashArr[i].group.children['CookTopSplashTracker'].bounds.width;
                height = cookTopSplashArr[i].group.children['CookTopSplashTracker'].bounds.height;

                length = DisplayFunctions.RoundPixelToInch(width);
                heightInches = DisplayFunctions.RoundPixelToInch(height);

                sum += length * heightInches;
            }
        }

        return sum;
    }

    static sumOutwardRadiuses(path: any) {
        var segments = path.segments;
        var segment, width;
        var sum = 0;

        for (let i = 0; i < segments.length; i++) {
            segment = segments[i];
            if (segment.data.radiusData && (segment.data.radiusData.direction == 1)) {
                width = DisplayFunctions.RoundPixelToInch(MathFunctions.getDistanceBetween(segment.point, segment.next.point));

                sum += width * segment.data.radiusData.depth;

            }
        }
        return sum;
    }

    static sumBumpOuts(path: any) {
        var segments = path.segments;
        var segment, curve, simpleLine, height;
        var sum = 0;

        for (let i = 0; i < segments.length; i++) {
            segment = segments[i];
            if (segment.data.bumpGroupData && !segment.data.bumpGroupData.bumpIn) {
                curve = path.curves[i];
                if (segment == segment.data.bumpGroupData.tangentSide) {
                    simpleLine = new SimpleLine(curve.previous.previous.point1, curve.next.next.point2);
                    height = DisplayFunctions.RoundPixelToInch(curve.previous.length);
                    sum += height * DisplayFunctions.RoundPixelToInch(MathFunctions.getLineLength(simpleLine));
                }
            }
        }
        return sum;
    }

    static calculatePathArea(path: any) {
        //return (path.area / (PIXEL_INCH_RATE*PIXEL_INCH_RATE));
        var pathArray = DataLayer.splitIntoPieces(path);

        var sum = 0;

        for (var i = 0; i < pathArray.length; i++) {
            //convertUnits(pathArray[i]);
            if (pathArray[i].useRectangle) {
                sum += DataLayer.calculateRectangleAreaMax(pathArray[i]);
            } else {
                sum += DataLayer.calculateTrapezoidalAreaMin(pathArray[i]);
            }

        }

        return sum;
    }

    static splitIntoPieces(path: any) {
        var shapeArr = [];
        var segments = path.segments, curves = path.curves;
        var v11, v21, v12, v22, vToV2;//, line2, line0;
        var n = segments.length;
        for (let i = 1; i <= (n / 2) - 1; i++) {
            //trapezoid: parallel lines.
            //line1 = new SimpleLine(curves[i-1].point1, curves[i-1].point2);
            //line3 = new SimpleLine(curves[n - (i + 1)].point1, curves[n - (i + 1)].point2);
            // split segment into 2 pairs v11-v22 and v12-V21 
            var midPoint1 = MathFunctions.getMidpoint(curves[i - 1].point1, curves[i - 1].point2);
            v11 = MathFunctions.getVectorBetweenPoints(curves[i - 1].point1, midPoint1);
            v12 = MathFunctions.getVectorBetweenPoints(midPoint1, curves[i - 1].point2);
            var midPoint2 = MathFunctions.getMidpoint(curves[n - (i + 1)].point1, curves[n - (i + 1)].point2);
            v21 = MathFunctions.getVectorBetweenPoints(curves[n - (i + 1)].point1, midPoint2);
            v22 = MathFunctions.getVectorBetweenPoints(midPoint2, curves[n - (i + 1)].point2);
            vToV2 = MathFunctions.getVectorBetweenPoints(curves[n - (i + 1)].point2, curves[i - 1].point1);
            var notAngle1 = DataLayer.isNot90Angle(curves[i - 1].segment1.angleDrawDataObj) ||
                DataLayer.isNot90Angle(curves[n - (i + 1)].segment2.angleDrawDataObj);
            var notAngle2 = DataLayer.isNot90Angle(curves[i - 1].segment2.angleDrawDataObj) ||
                DataLayer.isNot90Angle(curves[n - (i + 1)].segment1.angleDrawDataObj);

            shapeArr.push({
                parallelV: v11,
                a: DisplayFunctions.RoundPixelToInch(v11.length),
                b: DisplayFunctions.RoundPixelToInch(v21.length),
                vAToB: vToV2,
                useRectangle: notAngle1
            });
            shapeArr.push({
                parallelV: v12,
                a: DisplayFunctions.RoundPixelToInch(v12.length),
                b: DisplayFunctions.RoundPixelToInch(v22.length),
                vAToB: vToV2,
                useRectangle: notAngle2
            });
        }

        return shapeArr;
    }

    static isNot90Angle(angleDrawDataObj: any): boolean {
        if (angleDrawDataObj && angleDrawDataObj.group && angleDrawDataObj.group.content) {
            if (angleDrawDataObj.group.content.indexOf('90') === 0) {
                return false;
            }
            return true;
        }
        return false;
    }

    static calculateTrapezoidalAreaMin(dataObj: any) {
        var angle = dataObj.parallelV.angle;
        var l2Point1 = dataObj.vAToB.rotate(-1 * angle, new Point(0, 0));

        var height = Math.abs(l2Point1.y);

        height = DisplayFunctions.RoundPixelToInch(height);

        return height * ((dataObj.a + dataObj.b) / 2);
    }

    static calculateRectangleAreaMax(dataObj: any) {
        var angle = dataObj.parallelV.angle;
        var l2Point1 = dataObj.vAToB.rotate(-1 * angle, new Point(0, 0));

        var height = Math.abs(l2Point1.y);

        height = DisplayFunctions.RoundPixelToInch(height);

        return height * Math.max(dataObj.a, dataObj.b);
    }

    static convertRadiusLegendsToProductIDs(productQuoteGroup: any, dataObj: any, isCorner: boolean = false) {
        var retVal: any = {};
        var productId: number;
        var radiusArray = ApiService.getRadiusProductIDArr(productQuoteGroup);
        for (let radiusLegend in dataObj) {
            productId = DataLayer.getProductIDForLegend(radiusArray, radiusLegend) ?? -1;
            if (productId !== -1) {
                retVal[productId] = dataObj[radiusLegend];
            }
        }
        return retVal;
    }

    static getProductIDForLegend(radiusProductIDArr: number[], radiusLegend: any) {
        radiusLegend = radiusLegend.slice(1);
        if (radiusLegend == "s") {
            return null;
        }
        var i = Number(radiusLegend);
        if (i >= 0 && i < radiusProductIDArr.length)
            return radiusProductIDArr[i];
        return -1;
    }

    static isLaminate(ec: EdgeColorData): boolean {
        return (ec.p == 787 || ec.p == 784)
    }

}
